import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import type { ProductAction } from '@stores/product/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav from '@components/tabNav';
// import ProductDetail from './components/productList';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import CommonRulePopup from "@components/commonRulePopup";
import { px2rem } from '@utils/px2rem';
import { listenScrollDirection, getScrollPosition } from '@utils/scrollUtils';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Toast from '@components/Toast';
// 导入 Swiper 样式
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Image } from 'antd';
import updateImageListSrc from "@utils/update-image-list-src";
import ProductProgressBar from './components/productProgress';
import Avatar from '@components/avatar';
import parse from 'html-react-parser';
import dayjs from 'dayjs';
import CountDown from "@components/countDown";
import CommonPopupNew from "@components/commonPopupNew";
import { copy } from '@utils/copy';
import { Carousel } from 'antd';
import updateImageSrc from '@utils/update-image-src'

interface ProductDetailH5PageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    product?: ProductAction;
    productDetail?: any;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    navList?: any
    navCurrentIndex?: any
    navCurrentType?: any
    navClick?: Function
    productCodeData?: any
    productCodeList?: any
    getProductCodeData?: Function
    getproductDetailData?: Function
}
interface ProductDetailH5State {
    loading: boolean;
    error: any
    pageLoaded: any
    scrollY: any
    scrollDirection: any
    rulePopupStatus: boolean
    hideFirstPeopleList: boolean
    hideSecondPeopleList: boolean
    buyCodePopup: boolean
    myCodePopupStatus: boolean
    fileWorkDataPopupStatus: boolean
    expandMyCodeListStatus: boolean
    formData: any
    currentMyCodePopupType: any
    productEnrollData: any
    submitBtnStatus: boolean
    taskOpenFileWorkData: boolean
    downloadAppStatus: boolean; // 是否显示下载入口，用来记录下载入口的初始化状态，返回到其他页面后恢复下载入口的显示状态
    headerShowStatus: boolean;  // 是否显示header，用来记录header的初始化状态，返回到其他页面后恢复header的显示状态
    openAppTipPopupStatus: boolean  // 填写地址打开app提示弹框
    showFixedNav: boolean; // 是否显示悬浮导航
    fileWorkDataPopupType: any
}
@inject('app', 'site', 'user', 'product')
@observer
class ProductDetailH5Page extends BasePage<ProductDetailH5PageProps, ProductDetailH5State> {
    // 作为类属性直接定义
    scrollCleanup = null;
    private navBoxRef: HTMLDivElement | null = null;
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        downloadAppStatus: false, // 是否显示下载入口
        headerShowStatus: false,  // 是否显示header
        scrollY: 0, // 滚动高度
        scrollDirection: null,    // 滚动方向
        rulePopupStatus: false, // 规则弹框是否显示
        hideFirstPeopleList: false,  // 第一轮试用名单是否收起，默认展开
        hideSecondPeopleList: false,  // 第二轮试用名单是否收起，默认展开
        buyCodePopup: false,    // 积分兑换二次弹框是否显示
        myCodePopupStatus: false,   // 我的试用码弹框是否显示
        currentMyCodePopupType: 0,  // 为0弹框内展示的是试用码列表，为1弹框内展示的是当前此次报名获得的试用码信息
        fileWorkDataPopupStatus: false, // 填写作品链接弹框是否显示
        expandMyCodeListStatus: false,  // 是否展开我的试用码列表（默认不展开）
        formData: {     // 填写的表单
            type: '',    // 擅长创作的内容类型
            vivoLink: '',   // 社区作品链接
            otherLink: '',    // 站外作品链接
            other: '', // 扩展字段
        },
        productEnrollData: {
            trialCode: '69E5D8E5F3E78'
        },  // 报名后拿到的试用码数据
        submitBtnStatus: false, // 报名提交按钮是否高亮
        taskOpenFileWorkData: false,    // 是否是填写作品链接打开的表单弹框
        openAppTipPopupStatus: false, // 填写地址打开app提示弹框
        showFixedNav: false, // 悬浮导航是否显示
        fileWorkDataPopupType: 0,   // 0是报名打开，1是去填写、去修改打开弹框
    };
    async componentDidMount() {
        const { app, user, product, site } = this.props;
        if (site) {
        // console.log(site.getAppDownloadShowStatus(), '入口是否显示', site.getShowHeader(), 'header是否显示')
            // setTimeout(() => {
                this.setState({
                    downloadAppStatus: site.getAppDownloadShowStatus(),
                    headerShowStatus: site.getShowHeader(),

                }, () => {
                    site.setShowHeader(false);
                    site.setAppDownloadShowStatus(true);
                })
                
            // }, 100);
        }
        document.title = '新品体验官招募';
        // if (!user?.userInfo?.code) {
        //     const { user } = this.props as any;
        //     if (user && typeof user.checkLogin === 'function') {
        //         const isLogin = user.checkLogin();
        //         if (!isLogin) {
        //             return;
        //         }
        //     }
        //     // Toast.info({ content: '请先登录!' });
        //     return;
        // }

        // 初始化窗口尺寸和滚动位置
        this.scrollCleanup = listenScrollDirection((scrollData) => {
            this.setState({ 
              scrollDirection: scrollData.direction,
              scrollY: scrollData.scrollY
            });
            this.handleScrollDirection(scrollData.direction, scrollData.scrollY);
            this.handleScroll(scrollData.scrollY);
        });
        
        // 立即获取一次当前滚动位置
        const initialScrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
        this.handleScroll(initialScrollY);
        
        super.componentDidMount();
    }
    
    // 处理滚动，控制悬浮导航显示
    handleScroll = (scrollY: number) => {
        const navBoxOffsetTop = this.navBoxRef?.offsetTop || 600;
        const shouldShowFixed = scrollY > navBoxOffsetTop;
        
        // 只在状态改变时更新
        if (this.state.showFixedNav !== shouldShowFixed) {
            this.setState({ showFixedNav: shouldShowFixed });
        }
    }

    componentWillUnmount() {
        const { downloadAppStatus, headerShowStatus } = this.state;
        const { site } = this.props;

        if (typeof this.scrollCleanup === 'function') {
            this.scrollCleanup();
            this.scrollCleanup = null;
        }

        if (site) {
            site.setShowHeader(headerShowStatus);
            site.setAppDownloadShowStatus(downloadAppStatus);
        }
    }

    // 检测滚动方法
    handleScrollDirection = (direction, scroll) => {
        // 处理滚动方向变化的逻辑
        // console.log('检测到滚动:', direction, scroll);
        // this.setState({ scrollY });
    };

    // 立即下载
    downloadClick = (id: string | number) => {
        // this.props.history && this.props.history.push(`/topic/${id}`);
    };

    // 滑动变化回调
    handleSlideChange = (swiper) => {
        // this.setState({ activeIndex: swiper.activeIndex });
    };
    // 处理图片加载错误
    handleImageError = (index) => {
        console.warn(`图片 ${index + 1} 加载失败`);
    };


    // 处理导航点击
    handleNavClick = (item: any, index: number) => {
        // 调用父组件传递的函数
        const { navClick } = this.props;
        if (navClick) {
            navClick(item, index);
        }
    }

    // 在组件中计算动态top值
    getDynamicTop = () => {
        const { scrollDirection } = this.state;
        const { site } = this.props;
        
        if (site?.appDownloadShowStatus) {
        // 下载入口显示时：下滑176px，上滑88px
            return scrollDirection === 'down' ? px2rem(88) : px2rem(176);
        } else {
        // 下载入口隐藏时：下滑0px，上滑88px
            return scrollDirection === 'down' ? px2rem(88) : px2rem(0);
        }
    }

    // 关闭弹框
    onHidePopup = () => {
        this.setState({
            rulePopupStatus: false,
            buyCodePopup: false,
            openAppTipPopupStatus: false
        })
    }

    // 点击详情页分享按钮直接复制分享文案，并在复制完成后提示结果。
    handleShareClick = (shareText: string) => {
        try {
            copy(shareText);
            Toast.success({ content: '链接复制成功，快去分享好友吧～' });
        } catch (error) {
            Toast.error({ content: '复制失败，请稍后重试' });
        }
    };

    // 跳转到帖子详情页
    handleThreadClick = (item: any) => {
        const { user, app } = this.props as any;
        const platform = app?.platform || 'h5';
        
        // ✅ 检查登录状态（浏览帖子前检查）
        // if (user && typeof user.checkLogin === 'function') {
        //     const isLogin = user.checkLogin(platform);
        //     if (!isLogin) {
        //         console.log('[HandleThreadClick] User not logged in, abort thread view');
        //         return;
        //     }
        // }
        
        window.open(`/threadDetail/${item.id}`);
    };

    // type 1为立即报名；2为暂不填写；3为点击我的试用码
    registerProduct = (type) => {
        const { user, app } = this.props as any;
        const platform = app?.platform || 'h5';
        let { taskOpenFileWorkData } = this.state;
        
        // // ✅ 检查登录状态（报名前必须登录）
        // if (user && typeof user.checkLogin === 'function') {
        //     const isLogin = user.checkLogin(platform);
        //     if (!isLogin) {
        //         console.log('[RegisterProduct] User not logged in, abort register');
        //         return;
        //     }
        // }
        
        if(type == 1) { // 1为立即报名，调用报名接口，同时打开填写作品弹框
            this.submitProductEnrollDataClick(0);
        } else if(type == 2) {  // 2为暂不填写，跳过报名表单的填写，关闭报名表单弹框，打开报名成功结果页
            this.setState({
                fileWorkDataPopupStatus: false,
                myCodePopupStatus: taskOpenFileWorkData ? false : true
            })
        } else if(type == 3) {  // 3为点击我的试用码，打开试用码弹框，弹框内展示的是我的试用码列表以及获取试用码的任务列表
            this.setState({
                currentMyCodePopupType: 0,
                myCodePopupStatus: true
            })
        }
    }

    // 确认积分兑换试用码，调取购买试用码接口，成功后提示购买成功，失败弹出接口返回的error
    buyCodeConfirm = async () => {
        const { user, app, product, productDetail, getproductDetailData, getProductCodeData } = this.props as any;
        const platform = app?.platform || 'h5';
        
        // ✅ 检查登录状态（购买前必须登录）
        // if (user && typeof user.checkLogin === 'function') {
        //     const isLogin = user.checkLogin(platform);
        //     if (!isLogin) {
        //         console.log('[BuyCodeConfirm] User not logged in, abort purchase');
        //         return;
        //     }
        // }
        
        if(product) {
            let params = {
                trialId: productDetail.id
            }
            const res = await product.submitProductCodeExchangeData(params);
            if(res.code == 0) {
                Toast.success('购买成功');
                getproductDetailData && getproductDetailData();
                getProductCodeData && getProductCodeData();
                this.setState({
                    buyCodePopup: false,
                    currentMyCodePopupType: 0
                })
            } else {
                Toast.info(res.Message)
            }
        }   
    }
    // 报名， type为0是立即报名（没有表单），为1是填写表单的提交按钮报名
    submitProductEnrollDataClick  = async (type) => {
        const { user, app, product, productDetail, getproductDetailData, getProductCodeData } = this.props as any;
        const platform = app?.platform || 'h5';
        let { formData, fileWorkDataPopupType } = this.state;
        
        // ✅ 检查登录状态（提交表单前必须登录）
        // if (user && typeof user.checkLogin === 'function') {
        //     const isLogin = user.checkLogin(platform);
        //     if (!isLogin) {
        //         console.log('[SubmitProductEnroll] User not logged in, abort submission');
        //         return;
        //     }
        // }
        
        if(product) {
            let params = {
                trialId: productDetail.id,
                ...(formData.type && { type: formData.type }),
                ...(formData.vivoLink && { vivoLink: formData.vivoLink }),
                ...(formData.otherLink && { otherLink: formData.otherLink }),
                ...(formData.other && { other: formData.other })
            };
            const res = await product.submitProductEnrollData(params);
            if(res.code == 0) {
                if(type == 0) {
                    this.setState({
                        fileWorkDataPopupStatus: true,
                        currentMyCodePopupType: 1,
                    }, () => {
                        // 弹框打开后回填数据
                        this.fillFormDataFromEnrollInfo();
                    })
                } else if(type == 1) {
                    Toast.success(fileWorkDataPopupType == 0 ? '报名成功' : '提交成功')
                    this.setState({
                        currentMyCodePopupType: 1,
                        myCodePopupStatus: true,
                        productEnrollData: res.data,
                        fileWorkDataPopupStatus: false
                    })
                }
                getproductDetailData && getproductDetailData();
                getProductCodeData && getProductCodeData();
            } else {
                Toast.info(res.msg)
            }
        }   
    }

    // 获取邀请码
    getInviteLinkCreateData = async () => {
        const { user, app, product, productDetail } = this.props as any;
        const platform = app?.platform || 'h5';
        
        // ✅ 检查登录状态（获取邀请码前必须登录）
        // if (user && typeof user.checkLogin === 'function') {
        //     const isLogin = user.checkLogin(platform);
        //     if (!isLogin) {
        //         console.log('[GetInviteLink] User not logged in, abort invite');
        //         return;
        //     }
        // }
        
        const params = {
            type: 3,
            trial: productDetail.id,
        };
        if(product) {
            const res = await product.getInviteLinkCreate(params);
            // console.log(res, '获取邀请码');
            if (res.code == 0) {
                const isProdEnv = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';
                // {isProdEnv ? `${productDetail.product_type ? '【' + productDetail.product_type + '】' + productDetail.title : productDetail.title}\r\nhttps://club.vivo.com.cn/productDetail/${productDetail.id}\r\n复制本消息打开vivo社区App参与报名~` : `${productDetail.product_type ? '【' + productDetail.product_type + '】' + productDetail.title : productDetail.title}\r\nhttps://club.vivo.com.cn/productDetail/${productDetail.id}\r\n复制本消息打开vivo社区App参与报名~`}
                // const content = isProdEnv ? `https://club.vivo.com.cn/productDetail/${productDetail.id}?inviteCode=${res.data.code}` : `https://club-test.vivo.com.cn/productDetail/${productDetail.id}?inviteCode=${res.data.code}`;
                const content = isProdEnv ? `我正在参加${productDetail.title}，邀请你一起报名，同样有机会免费体验vivo最新产品!\r\nhttps://club.vivo.com.cn/productDetail/${productDetail.code}?inviteCode=${res.data.code}\r\n复制本消息打开vivo社区App参与报名~` : `我正在参加${productDetail.title}，邀请你一起报名，同样有机会免费体验vivo最新产品!\r\nhttps://club.vivo.com.cn/productDetail/${productDetail.code}?inviteCode=${res.data.code}\r\n复制本消息打开vivo社区App参与报名~`
                copy(content);
                Toast.success({ content: '链接已复制，快去分享给好友吧' });
            } else {
                Toast.error({ content: res.msg });
            }
        }
        
    }

    // 详情页轮播图
    renderProductSwiper = () => {
        const { productDetail, loading, hasMore, onLoadMore } = this.props;
        // console.log(productDetail, '产品列表');
        return (
            <div className={styles.carouselBox}>
                <Carousel
                    autoplay={true}
                    autoplaySpeed={3000}
                    draggable={true}
                    className={styles.CarouselList}
                    dots={productDetail?.trial_image.length > 1 ? { className: styles.customDots } : false}
                >
                    {productDetail?.trial_image?.map((item: any) => (
                        <img
                            src={updateImageListSrc(item, 12)}
                            className={styles.carouselImg}
                        />
                    ))}
                </Carousel>
            </div>
        )
    }

    // 填写地址打开app的新品众测详情页
    handleOpenAppConfirm = () => {
        let { productDetail } = this.props;
        this.setState({ openAppTipPopupStatus: false });
        const deepLink = `vivoclub://com.vivo.club/deep?page=page_product_crowd_test_detail&code=${productDetail.code}`;
        window.location.href = deepLink;
        // 3秒后如果应用没有打开，跳转到下载页
        setTimeout(() => {
            this.props.history.push(`/downloadAppEnter?deepLink=${encodeURIComponent(deepLink)}`);
            // window.open(`https://m.malink.cn/s/ABbE73`)
        }, 3000);
    };

    // 获取当前下载入口显示状态（实时从 store 获取）
    getDownloadAppStatus = (): boolean => {
        const { site } = this.props;
        return site?.appDownloadShowStatus ?? false;
    }
    // 获取页面顶部 paddingTop
    getWrapperPaddingTop = (): string | number => {
        const downloadAppStatus = this.getDownloadAppStatus();
        return downloadAppStatus ? px2rem(88) : 0;
    }

    // 第一轮试用名单
    renderFirstPeople = () => {
        const { productDetail, loading, hasMore, onLoadMore } = this.props;
        let {  } = this.state;
        // console.log(productDetail, '第一轮试用名单列表');
        return (
            <div className={styles.firstPersonList}>
                {productDetail?.first_people?.map((child, index) => {
                    // if (!listShow && index >= 18) return null;
                    return (
                        <div
                            key={index}
                            className={styles.personItem}
                        >
                            <Avatar avatarUrl={child?.avatar} userCode={child.code} size={60}></Avatar>
                            <div className={styles.nickname}>{child.nickname}</div>
                        </div>
                    )
                })}
            </div>
        )
    }

    // 第二轮试用名单
    renderSecondPeople = () => {
        const { productDetail, loading, hasMore, onLoadMore } = this.props;
        let {  } = this.state;
        // console.log(productDetail, '第二轮试用名单列表');
        return (
            <div className={styles.secondPersonList}>
                {productDetail?.second_people?.map((child, index) => {
                    // if (!listShow && index >= 18) return null;
                    return (
                        <div
                            key={index}
                            className={styles.personItem}
                        >
                            <Avatar avatarUrl={child?.avatar} userCode={child.code} size={60}></Avatar>
                            <div className={styles.nickname}>{child.nickname}</div>
                            <div className={styles.userCode}>{child.trial_code}</div>
                        </div>
                    )
                })}
            </div>
        )
    }

    // 优秀众测帖列表
    renderCollection = () => {
        const { productDetail, loading, hasMore, onLoadMore } = this.props;
        let {  } = this.state;
        return (
            <div className={styles.collectionList}>
                {productDetail?.collection?.map((item: any, idx: number) => (
                    <div key={item?.id ?? `collection-${idx}`} className={styles.collectionItem}>
                        {item.coverUrl != '' && <img src={item.coverUrl} alt="" className={styles.collectionCover} onClick={() => this.handleThreadClick(item)} />}
                        <div className={styles.collectionDetail}>
                            <div className={styles.collectionTitle} onClick={() => this.handleThreadClick(item)}>{item.title || item.summary}</div>
                            <div className={styles.collectionInfo}>
                                <div className={styles.collectionUserBox}>
                                    <Avatar avatarUrl={item.user?.avatar} officialSize={16} titleMark={item.user?.titleMark} size={32}></Avatar>
                                    <div className={styles.name}>{item.user?.nickname}</div>
                                </div>
                                <div className={styles.infoOperaBox}>
                                    <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                        <img src={`${BASE_IMG_URL}/common/comment.png`} alt="" className={styles.icon} />
                                        <div className={styles.count}>{item.postCount}</div>
                                    </div>
                                    <div className={styles.operaItem} onClick={() => this.handleThreadClick(item)}>
                                        <img src={`${BASE_IMG_URL}/common/like.png`} alt="" className={styles.icon} />
                                        <div className={styles.count}>{item.likeCount}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        )
    }

    // 当前用户入选信息
    renderSelectedInfo = (type = 1) => {
        const { productDetail, loading, hasMore, onLoadMore } = this.props;
        const first_round_at = dayjs(type == 1 ? productDetail.first_round_at : productDetail.second_round_at);
        const sevenDaysLater = first_round_at.add(7, 'day');
        const formattedDate = sevenDaysLater.format('MM-DD HH:mm');
        // console.log(productDetail, '第一轮试用名单列表');
        return (
            <div className={styles.selectedInfoBox}>
                {/* my_enroll_status null-未报名 0-已报名 1-第一轮名单 2-第二轮名单 */}
                {/* {productDetail?.my_enroll_status === null && <div className={styles.fail}>很遗憾您未入选，再接再厉</div>} */}
                <div className={styles.selectedInfo}>
                    <div className={styles.infoLeft}>
                        <div className={styles.userBox}>
                            <Avatar avatarUrl={productDetail.user?.avatar} size={60}></Avatar>
                            <div className={styles.userTip}>{productDetail?.my_enroll_status === null ? '很遗憾您未入选' : '恭喜您入选'}</div>
                        </div>
                        {/* 未填写地址 */}
                        {(!!!productDetail?.receiving_info && productDetail?.can_save_address) && <div className={styles.addressTip}>请于<span>{formattedDate}</span>前，前完成地址填写，以便邮寄试用产品</div>}
                        {/* 已填写地址 */}
                        {(!!productDetail?.receiving_info && productDetail?.can_save_address) && <div className={styles.addressTip}>感谢您的参与，期待您精彩的新品试用体验报告</div>}
                        {/* 已过期 */}
                        {(!!!productDetail?.receiving_info && !!!productDetail?.can_save_address) && <div className={styles.addressTip}>超过7天未确认地址信息，已视您为自动放弃试用机会</div>}
                    </div>
                    {/* 未填写地址 */}
                    {(!!!productDetail?.receiving_info && productDetail?.can_save_address) &&<div className={styles.addressBtn} onClick={() => {
                        this.setState({
                            openAppTipPopupStatus: true
                        })
                    }}>填写地址</div>}
                    {/* 已填写地址 */}
                    {(!!productDetail?.receiving_info && productDetail?.can_save_address) && <div className={styles.addressBtn1}>已填写地址</div>}
                    {/* 已过期 */}
                    {(!!!productDetail?.receiving_info && !!!productDetail?.can_save_address) && <div className={styles.addressBtn2}>已过期</div>}
                </div>
            </div>
        )
    }

    // 我的试用码弹框, type为0，展示试用码列表，为1展示我此次报名获得的试用码数据
    renderMyCodePopup = (type = 0) => {
        const { productDetail, productCodeData, productCodeList, getProductCodeData } = this.props;
        let { expandMyCodeListStatus, productEnrollData, taskOpenFileWorkData } = this.state;
        // console.log(productDetail?.tasks, '任务列表');
        // console.log(type, '类型', productCodeList)
        const canCompleteTask = productDetail.status == 1; // 是否可完成任务（活动进行中才能去完成任务）
        const productEnding = productDetail.status >= 2;    // 是否已结束
        let hasContent = false;
        if (productDetail.extend != null){
            // extend不为空:包含 other字段
           hasContent =  productDetail.enroll_info?.type || productDetail.enroll_info?.vivoLink || productDetail.enroll_info?.otherLink || productDetail.enroll_info?.other;
        } else {
            //extend为空:不包含 other字段
            hasContent = productDetail.enroll_info?.type || productDetail.enroll_info?.vivoLink || productDetail.enroll_info?.otherLink;     
        }
        return (
            <div className={classNames(styles.popupBox, styles.myCodePopup)}>
                <div className={styles.popupMask}></div>
                <div className={classNames(styles.popupContent, styles.myCodePopupContent)}>
                    <div className={styles.titleGap}></div>
                    {type == 0 && <>
                        <div className={styles.codeNum}>{productCodeData.length}</div>
                        <div className={styles.codeTip}>我的试用码</div>
                        <div className={styles.codeTip2}>当前的试用码数量已击败全国 <span>{productCodeData.ranking}</span> 的用户</div>
                        {/* 试用码列表 */}
                        <div className={styles.productCodeList}>
                            {productCodeList.length > 0 && productCodeList.map((code, index) => {
                                return <div className={styles.productCodeItem} key={index}>
                                    {code.type == 1 && <img src={`${BASE_IMG_URL}/product/task5.png`} alt="" className={styles.icon}/>}
                                    {code.type == 2 && <img src={`${BASE_IMG_URL}/product/task1.png`} alt="" className={styles.icon}/>}
                                    {code.type == 3 && <img src={`${BASE_IMG_URL}/product/task2.png`} alt="" className={styles.icon}/>}
                                    {code.type == 4 && <img src={`${BASE_IMG_URL}/product/task3.png`} alt="" className={styles.icon}/>}

                                    {code.type == 1 && <div className={styles.codeGetName}>报名成功</div>}
                                    {code.type == 2 && <div className={styles.codeGetName}>邀请新用户注册奖励</div>}
                                    {/* {code.type == 3 && <div className={styles.codeGetName}>每日发表帖子获得</div>} */}
                                    {code.type == 3 && <div className={styles.codeGetName}>内容获得3个点赞</div>}
                                    {code.type == 4 && <div className={styles.codeGetName}>使用100V币购买</div>}
                                    <div className={styles.code}>{code.trialCode}</div>
                                </div>
                            })}
                            {productCodeList.length > 5 && <div className={classNames(styles.codeMore, expandMyCodeListStatus ? styles.foldCodeMore : '')} onClick={() => {
                                getProductCodeData(expandMyCodeListStatus ? 1 : 0)
                            }}>{expandMyCodeListStatus ? '收起' : '查看更多试用码'}</div>}
                        </div>

                        {/* 分割线 */}
                        <div className={styles.listGap}>
                            <div className={styles.side}></div>
                            <div className={styles.center}></div>
                            <div className={styles.side}></div>
                        </div>
                    </>}
                    {type == 1 && <>
                        {productEnrollData?.trialCode && <div className={styles.currentCodeDataBox}>
                            <Avatar avatarUrl={productDetail.user?.avatar} titleMark={productDetail.user?.titleMark} size={120}></Avatar>
                            <div className={styles.currentCode}>{productEnrollData?.trialCode}</div>
                            <div className={styles.codeTip}>恭喜你获得1个试用码</div>
                            <div className={styles.codeTip2}>试用码越多抽中几率越大哦</div>
                        </div>}
                    </>}
                    
                    {/* 任务列表 */}
                    <div className={styles.productTaskList}>
                        <div className={styles.taskListTitle}>获取更多试用码</div>
                        {productDetail?.tasks?.map((task) => {
                            return <div className={styles.productTaskItem} key={task.type}>                         
                                {task.type == 'register' && <>
                                    <img src={`${BASE_IMG_URL}/product/task1.png`} alt="" className={styles.icon}/>
                                    <div className={styles.info}>
                                        <div className={styles.taskName}>每邀请1位新用户注册</div>
                                        <div className={styles.tip}>可获得5个试用码(不限次数)</div>
                                    </div>
                                    <div className={classNames(styles.taskBtn, (task.status || productEnding) ? styles.taskBtnOver : '')} onClick={() => {
                                        if(!task.status && canCompleteTask) {
                                            // ✅ 邀请任务 - 登录检查已在 getInviteLinkCreateData 中处理
                                            this.getInviteLinkCreateData();
                                        }
                                        
                                    }}>{productEnding ? '已结束' : task.status ? '已完成': '去邀请'}</div>
                                </>}
                                {task.type == 'like' && <>
                                    <img src={`${BASE_IMG_URL}/product/task2.png`} alt="" className={styles.icon}/>
                                    <div className={styles.info}>
                                        <div className={styles.taskName}>内容获得3个点赞</div>
                                        <div className={styles.tip}>每日可获得1个试用码</div>
                                    </div>
                                    <div className={classNames(styles.taskBtn, (task.status || productEnding) ? styles.taskBtnOver : '')} onClick={() => {
                                        if(!task.status && canCompleteTask) {
                                            // ✅ 发帖任务 - 登录检查
                                            // const { user, app } = this.props as any;
                                            // const platform = app?.platform || 'h5';
                                            // if (user && typeof user.checkLogin === 'function') {
                                            //     const isLogin = user.checkLogin(platform);
                                            //     if (isLogin) {
                                            //         this.props.history && this.props.history.push(`/setPost`);
                                            //     }
                                            // }
                                            this.props.history && this.props.history.push(`/setPost`);
                                        }
                                    } }>{productEnding ? '已结束' : task.status ? '已完成': '去发帖'}</div>
                                </>}
                                {task.type == 'buy' && <>
                                <img src={`${BASE_IMG_URL}/product/task3.png`} alt="" className={styles.icon}/>
                                    <div className={styles.info}>
                                        <div className={styles.taskName}>使用100V币购买</div>
                                        <div className={styles.tip}>每日可购买1个试用码</div>
                                    </div>
                                    <div className={classNames(styles.taskBtn, (task.status || productEnding) ? styles.taskBtnOver : '')} onClick={() => {
                                        if(!task.status && canCompleteTask) {
                                            // ✅ 购买任务 - 登录检查
                                            // const { user, app } = this.props as any;
                                            // const platform = app?.platform || 'h5';
                                            // if (user && typeof user.checkLogin === 'function') {
                                            //     const isLogin = user.checkLogin(platform);
                                            //     if (isLogin) {
                                            //         this.setState({
                                            //             buyCodePopup: true
                                            //         })
                                            //     }
                                            // }
                                             this.setState({
                                                buyCodePopup: true
                                            })
                                        }
                                        
                                    }}>{productEnding ? '已结束' : task.status ? '已完成': '去购买'}</div>
                                </>}
                                
                            </div>
                        })}
                    </div>
                    <div className={styles.productTaskList}>
                        <div className={styles.productTaskItem}>
                            {/* {productDetail?.tasks?.[0].type == 'enroll' && <> */}
                                <img src={`${BASE_IMG_URL}/product/task2.png`} alt="" className={styles.icon}/>
                                <div className={styles.info}>
                                    <div className={styles.taskName}>填写作品链接</div>
                                    <div className={styles.tip}>可优先获得试用名额</div>
                                </div>
                                <div className={classNames(styles.taskBtn, (productDetail.status > 2 || productDetail.my_enroll_status > 0) ? styles.taskBtnOver : '')} onClick={() => {
                                    if(canCompleteTask) {
                                        // ✅ 填写表单任务 - 登录检查
                                        // const { user, app } = this.props as any;
                                        // const platform = app?.platform || 'h5';
                                        // if (user && typeof user.checkLogin === 'function') {
                                        //     const isLogin = user.checkLogin(platform);
                                        //     if (isLogin) {
                                        //         this.setState({
                                        //             myCodePopupStatus: false,
                                        //             fileWorkDataPopupStatus: true,
                                        //             fileWorkDataPopupType: 1,
                                        //             taskOpenFileWorkData: true
                                        //         }, () => {
                                        //             // 弹框打开后回填数据
                                        //             this.fillFormDataFromEnrollInfo();
                                        //         })
                                        //     }
                                        // }
                                        this.setState({
                                            myCodePopupStatus: false,
                                            fileWorkDataPopupStatus: true,
                                            fileWorkDataPopupType: 1,
                                            taskOpenFileWorkData: true
                                        }, () => {
                                            // 弹框打开后回填数据
                                            this.fillFormDataFromEnrollInfo();
                                        })
                                    }
                                }}>{(productDetail.status > 2 || productDetail.my_enroll_status > 0) ? '已结束' : hasContent ? '去修改': '去填写'}</div>
                            {/* </>} */}
                        </div>
                    </div>
                    <div className={styles.closePopupBtnBox} onClick={() => {
                        this.setState({
                            myCodePopupStatus: false,
                            formData: {
                                type: '',    // 擅长创作的内容类型
                                vivoLink: '',   // 社区作品链接
                                otherLink: '',    // 站外作品链接
                                other: '', // 扩展字段
                            }
                        })
                    }}>
                        <div className={styles.closePopupBtn}>关闭</div>
                    </div>
                </div>
            </div>
        )
    }

    // 从enroll_info回填表单数据
    fillFormDataFromEnrollInfo = () => {
        const { productDetail } = this.props;
        const { enroll_info } = productDetail || {};
        
        // 如果enroll_info存在且不为空，回填数据
        if (enroll_info && Object.keys(enroll_info).length > 0) {
            const newFormData = {
                type: enroll_info.type || '',
                vivoLink: enroll_info.vivoLink || '',
                otherLink: enroll_info.otherLink || '',
                other: enroll_info.other || '',
            };
            
            // 检查是否有内容，更新按钮状态
            let hasContent = newFormData.type?.trim() || 
                            newFormData.vivoLink?.trim() || 
                            newFormData.otherLink?.trim();
            if (productDetail?.extend) {
                hasContent = hasContent || newFormData.other?.trim();
            }
            
            this.setState({
                formData: newFormData,
                submitBtnStatus: !!hasContent
            });
        }
    }

    // 处理表单输入变化
    handleInputChange = (field: string, value: string) => {
        const { formData } = this.state;
        const { productDetail } = this.props;
        const newFormData = {
            ...formData,
            [field]: value
        };
        // 检查是否有任何一个输入框有内容
        let hasContent = newFormData.type?.trim() || 
                        newFormData.vivoLink?.trim() || 
                        newFormData.otherLink?.trim();
        // 只有当productDetail?.extend为真时，才验证formData.other
        if (productDetail?.extend) {
            hasContent = hasContent || newFormData.other?.trim();
        }
        this.setState({
            formData: newFormData,
            submitBtnStatus: !!hasContent
        });
    }

    // 处理粘贴功能
    handlePaste = async (field: string) => {
        try {
            const text = await navigator.clipboard.readText();
            if (text) {
                this.handleInputChange(field, text);
                // Toast.success('粘贴成功');
            }
        } catch (err) {
            console.error('粘贴失败:', err);
            Toast.info('粘贴失败，请手动输入');
        }
    }

    // 填写作品链接弹框
    renderFileWorkData = () => {
        const { productDetail } = this.props;
        let { formData, submitBtnStatus, fileWorkDataPopupType } = this.state;
        return (
            <div className={classNames(styles.popupBox, styles.fileWorkPopup)}>
                <div className={styles.popupMask}></div>
                <div className={classNames(styles.popupContent, styles.fileWorkContent)}>
                    <div className={styles.registerUserBox}>
                        <Avatar avatarUrl={productDetail.user?.avatar} titleMark={productDetail.user?.titleMark} size={44}></Avatar>
                        <div className={styles.registerTip}>恭喜你报名成功！</div>
                    </div>
                    <div className={styles.formTip}>填写你的作品信息，<br/> 更有机会获得试用名额！</div>
                    <div className={styles.formTitle}>你擅长创作的内容类型：</div>
                    <div className={styles.inputFormBox}>
                        <input 
                            placeholder='包括但不限于评测、开箱、美图、摄影、视频/图文' 
                            value={formData.type} 
                            onChange={(e) => this.handleInputChange('type', e.target.value)}
                            className={styles.inputForm} 
                        />
                    </div>
                    <div className={styles.formTitle}>vivo社区作品链接：</div>
                    <div className={styles.inputFormBox}>
                        <textarea 
                            placeholder='粘贴你的作品链接，需以 https:// 开头，多个链接请分行填写' 
                            value={formData.vivoLink} 
                            onChange={(e) => this.handleInputChange('vivoLink', e.target.value)}
                            className={classNames(styles.inputForm, styles.textarea)}
                        ></textarea>
                        <img src={`${BASE_IMG_URL}/product/icon8.png`} alt="" className={styles.pasteIcon} onClick={() => this.handlePaste('vivoLink')}/>
                    </div>
                    <div className={styles.formTitle}>站外作品链接：</div>
                    <div className={styles.inputFormBox}>
                        <textarea 
                            placeholder='站外平台包括抖音、小红书、B站、快手、微博。粘贴你的作品链接，需以 https:// 开头，多个链接请分行填写' 
                            value={formData.otherLink} 
                            onChange={(e) => this.handleInputChange('otherLink', e.target.value)}
                            className={classNames(styles.inputForm, styles.textarea)}
                        ></textarea>
                        <img src={`${BASE_IMG_URL}/product/icon8.png`} alt="" className={styles.pasteIcon} onClick={() => this.handlePaste('otherLink')}/>
                    </div>
                    {productDetail?.extend && <><div className={styles.formTitle}>其他：</div>
                    <div className={styles.inputFormBox}>
                        <input 
                            placeholder='请输入' 
                            value={formData.other} 
                            onChange={(e) => this.handleInputChange('other', e.target.value)}
                            className={styles.inputForm} 
                        />
                    </div></>}
                    <div className={styles.fileWorkBtnBox}>
                        <div className={styles.noWrite} onClick={() => this.registerProduct(2)}>{fileWorkDataPopupType == 0 ? '暂不填写' : '取消'}</div>
                        <div 
                            className={classNames(styles.submitBtnGray, submitBtnStatus ? styles.submitBtn : '')} 
                            onClick={() => submitBtnStatus && this.submitProductEnrollDataClick(1)}
                        >提交</div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        let { navList, navCurrentIndex, navClick, productDetail, navCurrentType, productCodeData, productCodeList, site } = this.props;
        let { scrollY, rulePopupStatus, hideFirstPeopleList, hideSecondPeopleList, buyCodePopup, myCodePopupStatus, currentMyCodePopupType, fileWorkDataPopupStatus, openAppTipPopupStatus, showFixedNav } = this.state;
        // 从 site store 获取下载入口状态，确保关闭时能自动更新
        const downloadAppStatus = site?.appDownloadShowStatus ?? false;
        // console.log(navCurrentType, '---navCurrentType')
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };
        // console.log(currentMyCodePopupType, '弹框展示类型');
        const wrapperPaddingTop = this.getWrapperPaddingTop();
        return (
            <div className={styles.wrapper} style={{ paddingTop: wrapperPaddingTop }}>
                {productDetail?.id && <>
                    {/* 悬浮置顶的导航 */}
                    {showFixedNav && (
                        <div 
                            className={styles.fixedNavFilterBox} 
                            style={{top: downloadAppStatus ? px2rem(88) : 0}}
                        >
                            <TabNav navList={navList} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>
                        </div>
                    )}
                    
                    {productDetail?.trial_image?.length > 0 && this.renderProductSwiper()}
                    
                    <div className={styles.productContent}>
                        <div className={styles.infoBox}>
                            <div className={styles.titleBox}>
                                <div className={styles.title}>{productDetail.product_type ? '【' + productDetail.product_type + '】' + productDetail.title : productDetail.title}</div>
                                {/* 分享入口：直接复制当前新品体验官详情页的分享文案。 */}
                                <div
                                    className={styles.shareEnter}
                                    role="button"
                                    tabIndex={0}
                                    onClick={() => this.handleShareClick(`${productDetail.title}\r\nhttps://club.vivo.com.cn/productDetail/${productDetail.code}\r\n复制本消息打开vivo社区App参与报名~`)}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            event.preventDefault();
                                            this.handleShareClick(`${productDetail.title}\r\nhttps://club.vivo.com.cn/productDetail/${productDetail.code}\r\n复制本消息打开vivo社区App参与报名~`);
                                        }
                                    }}
                                >
                                    <img src={`${BASE_IMG_URL}/product/icon5.png`} alt="" className={styles.icon}/>
                                    <div className={styles.text}>分享</div>
                                </div>
                            </div>
                            <div className={styles.personNumBox}>
                                <div className={styles.personNum}>
                                    <img  src={`${BASE_IMG_URL}/product/icon1.png`} alt="" className={styles.icon}/>
                                    <div className={styles.text}>{productDetail.recruit || 0}个名额</div>
                                </div>
                                <div className={styles.personNum}>
                                    <div className={styles.text}>市场价：<span>{productDetail.price}</span></div>
                                </div>
                            </div>
                            <div className={styles.progressOuterBox}>
                                <div className={styles.progressBox}>
                                    {/* 进度 */}
                                    <ProductProgressBar data={productDetail} />
                                </div>
                            </div>
                        </div>

                        {/* tab切换内容，包括入选名单、报名规则、新品详情 */}
                        <div className={styles.tabContentBox} style={{paddingBottom: `calc(${(productCodeList?.length == 0 && productDetail?.status <= 1) ? px2rem(286) : px2rem(140)} + env(safe-area-inset-bottom, 0px))`}}>
                            <div className={styles.navBox} ref={(ref) => { this.navBoxRef = ref; }}>
                                <TabNav navList={navList} currentIndex={navCurrentIndex} navClick={(item:any, index:any) => this.handleNavClick(item, index)}></TabNav>
                            </div>
                            
                            <div className={styles.tabContent}>
                                {/* 优秀作品内容 */}
                                {navCurrentType == 'excellent' && <>
                                    <div className={styles.richtext}>
                                        {parse(updateImageSrc(productDetail?.result) || '提示', parserOptions)}
                                    </div>
                                    {/* 帖子合集 */}
                                    {productDetail?.collection.length > 0 && this.renderCollection()}
                                </>}
                                {/* 入选名单内容 */}
                                {navCurrentType == 'selected' && <>
                                    {productDetail?.second_round_is_end && <div className={styles.foldTitleBox}>
                                        <div className={styles.foldTitle}>
                                            <div className={styles.text}>第二轮试用名单</div>
                                            <img src={hideSecondPeopleList ? `${BASE_IMG_URL}/product/jt2.png` : `${BASE_IMG_URL}/product/jt1.png`} alt="" className={styles.foldIcon} onClick={() => {
                                                this.setState({
                                                    hideSecondPeopleList: !hideSecondPeopleList
                                                })
                                            }}/>
                                        </div>
                                        <div className={styles.personNum}><span>{productDetail?.second_people?.length}</span>人</div>
                                    </div>}

                                    {/* 如果当前用户入选第二轮试用名单 */}
                                    {productDetail?.my_enroll_status == 2 && this.renderSelectedInfo(2)}
                                    {/* 第二轮名单 */}
                                    {!hideSecondPeopleList && this.renderSecondPeople()}

                                    {productDetail?.first_round_is_end && <div className={styles.foldTitleBox}>
                                        <div className={styles.foldTitle}>
                                            <div className={styles.text}>第一轮试用名单</div>
                                            <img src={hideFirstPeopleList ? `${BASE_IMG_URL}/product/jt2.png` : `${BASE_IMG_URL}/product/jt1.png`} alt="" className={styles.foldIcon} onClick={() => {
                                                this.setState({
                                                    hideFirstPeopleList: !hideFirstPeopleList
                                                })
                                            }}/>
                                        </div>
                                        <div className={styles.personNum}><span>{productDetail?.first_people?.length}</span>人</div>
                                    </div>}
                                    {/* 如果当前用户入选第一轮试用名单 */}
                                    {productDetail?.my_enroll_status == 1 && this.renderSelectedInfo(1)}
                                    {/* 第一轮名单 */}
                                    {!hideFirstPeopleList && this.renderFirstPeople()}
                                </>}

                                {/* 报名规则内容 */}
                                {navCurrentType == 'rule' && <>
                                    <div className={styles.richtext}>
                                        {parse(updateImageSrc(productDetail?.rule) || '提示', parserOptions)}
                                    </div>
                                    <div className={styles.contentBottomSafeArea} aria-hidden="true" />
                                </>}

                                {/* 新品详情内容 */}
                                {navCurrentType == 'detail' && <>
                                    <div className={styles.richtext}>
                                        {parse(updateImageSrc(productDetail?.content) || '提示', parserOptions)}
                                    </div>
                                    <div className={styles.contentBottomSafeArea} aria-hidden="true" />
                                </>}
                            </div>
                        </div>

                        {/* 底部按钮 状态有：1、倒计时+立即报名  2、我的试用码 */}
                        <div className={styles.bottomFixedBox}>
                            {(productDetail?.status == 0 || productDetail?.status == 1) &&  <>
                                {/* 倒计时 */}
                                <CountDown number={productDetail?.status == 0 ? productDetail.enroll_start_at: productDetail.enroll_end_at} endText={productDetail?.status == 0 ? '后开始报名': '后结束报名'} boxStylesData={{justifyContent:'center'}}/>
                            </>}
                            <div className={styles.bottomBtnBox}>
                                <img src={`${BASE_IMG_URL}/product/icon6.png`} alt="" className={styles.backIcon} onClick={() => {
                                    window.ensureBack(
                                        () => {
                                        //   console.log('返回完成');
                                        }
                                    );
                                }}/>

                                {/* 未开始 */}
                                {productDetail?.status == 0 &&<div className={styles.noStartBtn}>即将开始</div>}
                                {/* 未报名，且未结束，显示立即报名 */}
                                {(productCodeList?.length == 0 && productDetail?.status == 1) &&<div className={styles.registerNow} onClick={() => {
                                    if (!this.props.user?.userInfo?.code) {
                                        const { user } = this.props as any;
                                        if (user && typeof user.checkLogin === 'function') {
                                            const isLogin = user.checkLogin();
                                            if (!isLogin) {
                                                return;
                                            }
                                        }
                                        Toast.info({ content: '请先登录!' });
                                        return;
                                    }
                                    this.registerProduct(1)}
                                }>立即报名</div>}
                                {/* 未报名，但报名时间已截止，显示入选名单待公布 */}
                                {/* {(productCodeList?.length == 0 && productDetail?.status == 2) &&<div className={styles.registerNow} onClick={() => this.registerProduct(1)}>入选名单待公布</div>} */}
                                {/* 报了名，有试用码，但是报名已截止，显示“我的试用码”线性按钮 */}
                                {(productCodeList?.length > 0 && productDetail?.status >= 2) && <div className={classNames(styles.myCodeBtn, styles.myCodeBtn2)} onClick={() => this.registerProduct(3)}>我的试用码({productCodeList?.length})</div>}
                                {/* 报了名，有试用码，但是报名还没截止，显示“获取更多试用码”实心按钮 */}
                                {(productCodeList?.length > 0  && productDetail?.status == 1) && <div className={classNames(styles.myCodeBtn)} onClick={() => this.registerProduct(3)}>获取更多试用码({productCodeList?.length})</div>}
                                {/* 未报名，已结束 */}
                                {(productCodeList?.length == 0 && productDetail?.status >= 2) && <div className={styles.registerEnd}>报名已结束</div>}
                            </div>
                            
                        </div>
                        {myCodePopupStatus && this.renderMyCodePopup(currentMyCodePopupType)}
                        {fileWorkDataPopupStatus && this.renderFileWorkData()}
                    </div>

                    <CommonPopupNew
                        visible={openAppTipPopupStatus}
                        useRichtext={true}
                        title="<p>请前往vivo社区App端<br/>填写收货地址</p>"
                        confirmText="打开App端"
                        onCancelChange={this.onHidePopup}
                        onConfirmButtonChange={this.handleOpenAppConfirm}
                    />

                    {/* v币购买试用码二次弹框 */}
                    <CommonPopupNew
                        visible={buyCodePopup}
                        title="购买试用码"
                        confirmText="确定"
                        onCancelChange={() => this.onHidePopup()}
                        onConfirmButtonChange={() => this.buyCodeConfirm()}
                        >
                        {/* children 插槽内容 */}
                        <div className={styles.popupTip}>确定使用100V币购买试用码？</div>
                    </CommonPopupNew>

                </>}
            </div>
        )
    }
}

export default withRouter(ProductDetailH5Page);
